export const attrGrpAttrAssocObj = "groupAttributes";
export const attrValAssocObj = "attributeValues";
